import React from 'react';
import { IRequestContext } from '@msdyn365-commerce/core';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';

const AuthorizedDealerBadge = ({ brand, requestContext }: { brand?: string | null; requestContext: IRequestContext }) => {
    if (brand && requestContext.gridSettings) {
        const locale = requestContext.locale;
        const fileName = `Catalogs/${locale}/${brand.toUpperCase()}_AuthDLR_${locale}.png`;
        const categoryImageUrl = generateImageUrl(fileName, requestContext.apiSettings);

        if (categoryImageUrl) {
            const ImageData: Msdyn365.IImageData = { src: categoryImageUrl };
            return (
                <div className='hei-buybox-wrapper-auth-dlr'>
                    <Msdyn365.Image
                        className='hei-buybox-image__item'
                        altText={brand}
                        {...ImageData}
                        gridSettings={requestContext.gridSettings}
                        loadFailureBehavior='hide'
                        role='banner'
                        id={`${fileName}__authDLR`}
                    />
                </div>
            );
        }
    }

    return null;
};

export { AuthorizedDealerBadge };
